import { render, staticRenderFns } from "./AppPlayerProps.vue?vue&type=template&id=20ea657a&"
import script from "./AppPlayerProps.vue?vue&type=script&lang=js&"
export * from "./AppPlayerProps.vue?vue&type=script&lang=js&"
import style0 from "./AppPlayerProps.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports